import { render } from "./CWidgetBrand.vue?vue&type=template&id=4d42f382"
import script from "./CWidgetBrand.vue?vue&type=script&lang=js"
export * from "./CWidgetBrand.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__